export const common = {
  // 导航
  'nav.features': '功能',
  'nav.howItWorks': '工作原理',
  'nav.pricing': '价格',
  'nav.faq': '常见问题',
  'nav.aboutUs': '关于我们',
  'nav.getStarted': '开始使用',

  // 关于我们部分
  'aboutUs.badge': "关于我们",
  'aboutUs.title': "IdeaVerdict 为何而存在",
  'aboutUs.line1': "人人都能有个想法。",
  'aboutUs.line2': "却很少有人承认自己的想法站不住脚。",
  'aboutUs.paragraph1':
    "大多数想法失败，不是因为创始人缺乏勇气。而是因为没人在足够早的时候告诉他们真相。IdeaVerdict 就是来填这个缺口的——我们给你朋友不愿意给你的那种直白判断。",
  'aboutUs.belief1a': "我们不卖噱头。",
  'aboutUs.belief1b': "我们交易的是市场信号。",
  'aboutUs.belief2a': "我们不卖鸡汤。",
  'aboutUs.belief2b': "我们卖的是对需求、竞争与可行性的清晰判断。",
  'aboutUs.mission1': "我们的工作不是让你的想法看起来不错。",
  'aboutUs.mission2': "我们的工作是告诉你它到底行不行。",
  'aboutUs.analysis':
    "IdeaVerdict 只评估真正决定结果的东西——市场结构、真实需求、竞争格局、所需资本、变现周期、可扩展性。没有情绪。没有乐观。只有分析。",
  'aboutUs.failure1': "大多数生意都会失败。",
  'aboutUs.failure2': "不是因为做事的人不行——",
  'aboutUs.failure3': "而是因为没人在足够早的时候，用足够大的力气把他们顶回去。",
  'aboutUs.clarity': "我们存在，就是为了顶回去。",
  'aboutUs.value1': "直接。",
  'aboutUs.value2': "诚实。",
  'aboutUs.value3': "快。",
  'aboutUs.confirm': "想法有料，我们挺你。",
  'aboutUs.deny': "没料，我们当面跟你说。",
  'aboutUs.noApplause': "不鼓掌。",
  'aboutUs.noSugarcoating': "不粉饰。",
  'aboutUs.noTheater': "不演戏。",
  'aboutUs.noHype': "只给你判决。",
  // 主页英雄区
  'hero.badge': '60 秒内获得 AI 裁决',
  'hero.title1': '在验证之前',
  'hero.title2': '别动手。',
  'hero.subtitle': 'IdeaVerdict 像一个挑剔的 VC 一样压力测试你的想法。',
  'hero.subtitleLine2': '几秒内的诚实裁决 — 没有炒作，没有奉承。',
  'hero.cta': '获取我的裁决',
  'hero.ctaSecondary': '了解工作原理',
  'hero.stat1Value': '30',
  'hero.stat1Label': '每次请求消耗积分',
  'hero.stat2Value': '7+ 个',
  'hero.stat2Label': '评估维度',
  'hero.stat3Value': '100%',
  'hero.stat3Label': '诚实且私密',

  // 功能部分
  'features.title1': '为想要听到',
  'features.title2': '真相的',
  'features.title3': '创业者打造',
  'features.bullet1.title': '数秒内得出诚实结论',
  'features.bullet1.description':
    '强、中、弱——附带每个评级背后的理由。不鼓掌、不粉饰、不演戏。',
  'features.bullet2.title': '围绕真正重要的指标打分',
  'features.bullet2.description':
    '您的想法将根据真实需求、竞争、所需资金、回款周期和可扩展性进行评分——不靠感觉。',
  'features.bullet3.title': '从结论到落地',
  'features.bullet3.description':
    'Builder 模式将通过的想法转化为开发者简报：用户流程、核心功能、技术备注。',

  // 工作原理
  'howItWorks.title': '工作原理',
  'howItWorks.subtitle': '四个步骤，清晰了解您的商业利基。',
  'howItWorks.step1Title': '选择方案',
  'howItWorks.step1Desc': '入门版、专业版或构建者版 – 取决于您的审核深度。',
  'howItWorks.step2Title': '询问人工智能',
  'howItWorks.step2Desc': '提出您关于利基的问题。每次请求消耗 30 积分。',
  'howItWorks.step3Title': '获得诚实 verdict',
  'howItWorks.step3Desc': '人工智能评级：好、一般或差。没有粉饰。',
  'howItWorks.step4Title': '做出决定',
  'howItWorks.step4Desc': '现在您知道是否值得继续推进。',

  // 价格
  'pricing.title': '价格',
  'pricing.subtitle': '选择适合您审核深度的方案。',
  'pricing.monthly': '按月',
  'pricing.yearly': '按年',
  'pricing.yearlyDiscount': '年度订阅：',
  'pricing.yearlyDiscountValue': '-20% 折扣',
  'pricing.perMonth': '/月',
  'pricing.selectPlan': '选择方案',
  'pricing.mostPopular': '最受欢迎',
  'pricing.footer': '所有价格均以瑞士法郎为单位。仅在成功获得人工智能响应后扣除积分。',

  // 价格功能 (Pricing Features)
  'pricing.feature1': '免费聊天（无表单）',
  'pricing.feature2': '市场逻辑与诚实评级',
  'pricing.feature3': '永久聊天记录',
  'pricing.feature4': '多个平行聊天会话',
  'pricing.feature5': '完全多语言支持',
  'pricing.feature6': '基于积分的使用',
  'pricing.feature7': '每月重置',
  'pricing.feature8': '市场分析',
  'pricing.feature9': '总结',
  'pricing.feature10': '优势',
  'pricing.feature11': '弱点',
  'pricing.feature12': '机会',
  'pricing.feature13': '风险',
  'pricing.feature14': '建议',
  'pricing.feature15': '下载 PDF',
  'pricing.feature16': '无开发者简报',
  'pricing.feature17': '构建者模式：开发者简报',
  'pricing.feature18': '结构化总结',

  // 入门版方案
  'pricing.starter.name': '入门版',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': '访问人工智能利基聊天机器人',
  'pricing.starter.credits': '每月 2,500 积分',
  'pricing.starter.feature1': '生成利基想法',
  'pricing.starter.feature2': '优化利基',
  'pricing.starter.feature3': '市场现实检查',
  'pricing.starter.feature4': '竞争评估',
  'pricing.starter.feature5': '时间评估',
  'pricing.starter.feature6': '诚实 verdict',
  'pricing.starter.feature7': '私密会话',
  'pricing.starter.feature8': '历史记录与导出',

  // 专业版方案
  'pricing.pro.name': '专业版',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': '访问人工智能利基聊天机器人',
  'pricing.pro.credits': '每月 5,000 积分',
  'pricing.pro.feature1': '所有入门版功能',
  'pricing.pro.feature2': '更多积分，用于深入审核',
  'pricing.pro.feature3': '改进建议',
  'pricing.pro.feature4': '替代利基',
  'pricing.pro.feature5': '详细市场分析',
  'pricing.pro.feature6': '优先支持',
  'pricing.pro.feature7': '高级筛选',
  'pricing.pro.feature8': '会话收藏夹',

  // 构建者方案
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "全部功能 + Builder 模式",
  'pricing.builder.credits': "每月 10,000 积分",
  'pricing.builder.feature1': '所有专业版功能',
  'pricing.builder.feature2': '无限人工智能请求',
  'pricing.builder.feature3': '构建者模式：开发者简报',
  'pricing.builder.feature4': '结构化项目概览',
  'pricing.builder.feature5': '用户流程与核心功能',
  'pricing.builder.feature6': '技术说明',
  'pricing.builder.feature7': '定义非目标',
  'pricing.builder.feature8': '公平使用速率限制',
  'pricing.builder.limitNote': '公平使用限制',
  'pricing.monthlyReset': '每月重置',

  // 模态框
  'pricing.modal.selected': '已选择',
  'pricing.modal.comingSoon': '注册和支付处理即将推出。',
  'pricing.modal.patience': '我们正在努力为您提供安全无缝的体验。请耐心等待。',
  'pricing.modal.understood': '知道了',

  // 常见问题
  'faq.title': '常见问题',
  'faq.subtitle': '诚实且批判性地回答。',
  'faq.q1': "IdeaVerdict 到底做什么？",
  'faq.a1': "我们对决定结果的几件事打分——真实需求、竞争、所需资本、上市时间、可扩展性。\n想法站得住脚，我们告诉你怎么打磨得更锋利。\n站不住脚，我们也照实说。",
  'faq.q2': "你们也生成想法吗？",
  'faq.a2': "是的——但不会胡乱蹦出建议。\n想法来自真实的市场空缺，而不是这周流行什么。",
  'faq.q3': "你们改进已有的商业模式吗？",
  'faq.a3': "改，前提是有东西可改。\n我们不给烂想法刷漆——只强化本来就有底子的。",
  'faq.q4': "你们和其他 AI 工具有什么不同？",
  'faq.a4': "大多数 AI 工具会说你的想法很棒。\n我们告诉你它是不是真的棒。\n差别：现实主义，不是热情。",
  'faq.q5': "这能保证我成功吗？",
  'faq.a5': "不能。\n我们帮你避开烂赌注——风险不会消失，但你睁着眼睛进场。",
  'faq.q6': "IdeaVerdict 适合谁？",
  'faq.a6': "上线前的创始人。\n开始周末项目前的开发者。\n下一次下注前的操盘手。\n签字前的投资人。\n\n所有想在投入前看清状况的人。",
  'faq.q7': "如果我只想要点鼓励呢？",
  'faq.a7': "那 IdeaVerdict 不是你要找的工具。\n我们给的是诚实的判断，不是安慰。",
  'faq.q8': "你们的分析到底有多诚实？",
  'faq.a8': "数据允许的范围内，尽可能诚实。\n不会为了照顾你的感受而软化一个糟糕的判决。",
  'faq.q9': "这能代替真正的市场调研吗？",
  'faq.a9': "不能。\n这是投入前的快速战略检查——不是 50 页的市场研究。",
  'faq.q10': "为什么这么直接？",
  'faq.a10': "因为做错的东西，要赔上你几个月。\n而一个诚实的判决，只要几分钟。\n\n我们选几分钟。",
  // 页脚
  'footer.description': 'IdeaVerdict 不是为了让你感觉良好。它是为了帮你做出正确决定。',
  'footer.product': '产品',
  'footer.aiAssistant': '人工智能助手',
  'footer.howItWorks': '工作原理',
  'footer.pricing': '价格',
  'footer.faq': '常见问题',
  'footer.legal': '法律信息',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.imprint': '版本说明',
  'footer.support': '支持',
  'footer.contact': '联系我们',
  'footer.documentation': '文档',
  'footer.copyright': '© 2026 IdeaVerdict。保留所有权利。',

  // 人工智能助手
  'aiAssistant.title': '人工智能利基助手',
  'aiAssistant.subtitle': '询问关于利基的问题',
  'aiAssistant.welcomeMessage': '您好！描述您的想法或向我询问关于利基的问题。我会给您一个清晰诚实的评估。',
  'aiAssistant.demoResponse': '这是一个演示。要获得真正的人工智能评估，请注册并选择一个方案。',
  'aiAssistant.placeholder': '描述您的想法...',

  // 头部和侧边栏
  'dashboard.header.title': '仪表板',
  'dashboard.header.aiAssistant': '您的人工智能助手',
  'header.logout': '退出登录',
  'dashboard.sidebar.overview': '概览',
  'dashboard.sidebar.aiChat': '人工智能助手',
  'dashboard.sidebar.newAnalysis': '人工智能助手',
  'dashboard.sidebar.history': '历史记录',
  'dashboard.sidebar.credits': '积分',
  'dashboard.sidebar.settings': '设置',

  // 仪表板概览
  'dashboard.overview.welcome': '欢迎回来，{{name}}',
  'dashboard.overview.subtitle': '以下是您活动的快速概览',

  // 仪表板统计
  'dashboard.stats.creditsRemaining': '剩余积分',
  'dashboard.stats.totalAnalyses': '总分析次数',
  'dashboard.stats.goodRatings': '好评数量',
  'dashboard.stats.nextReset': '下次重置倒计时',
  'dashboard.stats.days': '天',

  // 快速操作
  'dashboard.quickActions.title': '快速操作',
  'dashboard.quickActions.checkNewIdea': '评估一个想法',
  'dashboard.quickActions.checkNewIdeaDesc': '分析一个现有的商业想法',
  'dashboard.quickActions.generateIdea': '生成一个想法',
  'dashboard.quickActions.generateIdeaDesc': '寻找一个新的有利可图的利基',
  'dashboard.quickActions.builderBriefing': '构建者简报',
  'dashboard.quickActions.builderBriefingDesc': '将一个想法转化为开发者就绪的简报',
  'dashboard.quickActions.premiumOnly': '仅限构建者版',

  // 聊天头部
  'chat.title': '人工智能利基助手',
  'chat.subtitle': '询问关于利基的问题。我会批判性地、诚实地评估。',
  'chat.creditsLabel': '积分',

  // 聊天欢迎语
  'chat.welcomeTitle': '欢迎使用人工智能利基助手',
  'chat.welcomeDesc': '描述您的想法或询问关于利基的问题。我会诚实地评估：好、一般或差。',
  'chat.aiWelcome': '您好！描述您的想法或向我询问关于利基的问题。我会给您一个清晰诚实的评估。',

  // 聊天建议
  'chat.suggestion1': '我想为自由职业者建一个管理发票的SaaS工具。这是个好利基吗？',
  'chat.suggestion2': '帮我找一个竞争低的在线生意，可以用500美元起步，不需要编程。',
  'chat.suggestion3': '评估一下：为有饮食限制的忙碌父母设计的AI餐食规划应用。',
  'chat.suggestion4': '我想在Etsy上向小企业主销售数字模板。诚实分析这个利基。',

  // 聊天操作
  'chat.newConversation': '新建对话',
  'chat.today': '今天',
  'chat.yesterday': '昨天',
  'chat.thisWeek': '本周',
  'chat.thisMonth': '本月',
  'chat.older': '更早',
  'chat.messages': '条消息',
  'chat.renameConversation': '重命名',
  'chat.deleteConversation': '删除',
  'chat.cancel': '取消',
  'chat.rename': '重命名',
  'chat.delete': '删除',
  'chat.favorite': '添加到收藏',
  'chat.unfavorite': '取消收藏',
  'chat.searchSessions': '搜索对话...',
  'chat.noResults': '未找到结果',
  'chat.noSessions': '暂无对话',
  'chat.enterNewName': '输入新名称...',
  'chat.deleteConfirmMessage': '您确定要删除此对话吗？此操作无法撤销。',

  // 聊天输入和错误
  'chat.inputPlaceholder': '输入您的问题… (消耗 30 积分)',
  'chat.send': '发送',
  'chat.voice': '语音输入',
  'chat.listeningPlaceholder': '正在聆听... 请现在说话。',
  'chat.stopListening': '停止聆听',
  'chat.recording': '录音中...',
  'chat.speechNotSupported': '您的浏览器不支持语音识别。',
  'chat.microphonePermissionDenied': '麦克风访问被拒绝。请在浏览器设置中允许访问。',
  'chat.errorNotEnoughCredits': '积分不足。请升级您的套餐或等待下次重置。',
  'chat.errorAiFailed': '人工智能响应失败。未扣除任何积分。',
  'chat.errorRateLimit': '请求过多。请稍等片刻。',

  // 评级
  'rating.good': '好',
  'rating.medium': '一般',
  'rating.bad': '差',

  // 认证页面
  'auth.branding.headline1': '并非每个想法都是好的。',
  'auth.branding.headline2': '我们诚实地告诉你。',
  'auth.branding.subtitle': '一个面向商业利基的决策人工智能。清晰。批判。不粉饰。',
  'auth.benefits.privacy.title': '100% 私密',
  'auth.benefits.privacy.desc': '您的想法完全保持私密和安全。',
  'auth.benefits.honest.title': '诚实的人工智能',
  'auth.benefits.honest.desc': '没有粉饰——只有清晰、批判性的反馈。',
  'auth.benefits.fast.title': '快速结果',
  'auth.benefits.fast.desc': '在几分钟内获得关于您利基的清晰度。',
  'auth.trust.users': '活跃用户',
  'auth.trust.ideas': '已分析想法',
  'auth.trust.rating': '用户评分',
  'auth.login.title': '登录',
  'auth.login.headline': '欢迎回来',
  'auth.login.subtitle': '登录以继续您的旅程。',
  'auth.login.forgotPassword': '忘记密码？',
  'auth.login.submit': '登录',
  'auth.login.noAccount': '还没有帐户？',
  'auth.login.signUp': '注册',
  'auth.register.title': '注册',
  'auth.register.headline': '创建您的帐户',
  'auth.register.subtitle': '今天就开始分析您的商业想法。',
  'auth.register.submit': '创建帐户',
  'auth.register.hasAccount': '已经有帐户了？',
  'auth.register.signIn': '登录',
  'auth.fields.name': '全名',
  'auth.fields.email': '电子邮件地址',
  'auth.fields.password': '密码',
  'auth.fields.confirmPassword': '确认密码',
  'auth.fields.selectPlan': '选择您的方案',
  'auth.fields.testCode': '登录并免费测试',
  'auth.placeholders.name': '输入您的姓名',
  'auth.placeholders.email': '输入您的电子邮件',
  'auth.placeholders.password': '输入您的密码',
  'auth.placeholders.confirmPassword': '确认您的密码',
  'auth.placeholders.testCode': '输入测试代码',
  'auth.terms.accept': '我接受',
  'auth.terms.terms': '服务条款',
  'auth.privacy.accept': '我接受',
  'auth.privacy.policy': '隐私政策',
  'auth.errors.nameRequired': '姓名是必填项',
  'auth.errors.emailRequired': '电子邮件是必填项',
  'auth.errors.emailInvalid': '请输入有效的电子邮件地址',
  'auth.errors.passwordRequired': '密码是必填项',
  'auth.errors.passwordLength': '密码长度至少为 8 个字符',
  'auth.errors.passwordMismatch': '两次输入的密码不匹配',
  'auth.errors.invalidCode': '代码无效或已过期',
  'auth.errors.registrationCodeOnly': '此代码仅用于注册',
  'auth.errors.verificationFailed': '验证代码时出错。请重试。',
  'auth.loading': '请稍候...',
  'auth.or': '或继续使用',
  'auth.social.google': '使用 Google 继续',
  'auth.social.apple': '使用 Apple 继续',
  'auth.actions.verify': '验证',
  'auth.testCode.activated': '测试代码已激活！',
  'auth.testCode.days': '天',
  'auth.testCode.months': '个月',
  'auth.testCode.freeAccess': '免费访问',
  'auth.testCode.credits': '积分',

  // 电子邮件验证
  'auth.verification.title': '验证电子邮件',
  'auth.verification.headline': '查收您的收件箱',
  'auth.verification.subtitle': '我们已将验证码发送至：',
  'auth.verification.codeLabel': '验证码',
  'auth.verification.codePlaceholder': '输入 6 位验证码',
  'auth.verification.submit': '验证电子邮件',
  'auth.verification.resend': '重新发送代码',
  'auth.verification.resendIn': '重新发送倒计时',
  'auth.verification.seconds': '秒',
  'auth.verification.success': '电子邮件验证成功！',
  'auth.verification.error': '验证码无效。请重试。',
  'auth.verification.expired': '代码已过期。请申请新的代码。',
  'auth.verification.sent': '新代码已发送！',
  'auth.verification.checkSpam': '没有收到？请检查您的垃圾邮件文件夹。',

  // 忘记密码
  'auth.forgot.title': '忘记密码',
  'auth.forgot.headline': '重置您的密码',
  'auth.forgot.subtitle': '输入您的电子邮件地址，我们将向您发送重置链接。',
  'auth.forgot.submit': '发送重置链接',
  'auth.forgot.backToLogin': '返回登录',
  'auth.forgot.success': '邮件已发送！',
  'auth.forgot.successMessage': '我们已向您发送了一封包含重置密码说明的电子邮件。',
  'auth.forgot.checkInbox': '查收您的收件箱',

  // 重置密码
  'auth.reset.title': '新密码',
  'auth.reset.headline': '设置新密码',
  'auth.reset.subtitle': '输入您的新密码。',
  'auth.reset.newPassword': '新密码',
  'auth.reset.confirmNewPassword': '确认新密码',
  'auth.reset.submit': '更改密码',
  'auth.reset.success': '密码更改成功！',
  'auth.reset.successMessage': '您现在可以使用新密码登录。',
  'auth.reset.loginNow': '立即登录',

  // 法律页面
  'legal.backToAuth': '返回登录',
  'legal.allRightsReserved': '保留所有权利。',

  // 服务条款页面
  'legal.terms.title': '服务条款',
  'legal.terms.lastUpdated': '最后更新',
  'legal.terms.section1.title': '1. 范围',
  'legal.terms.section1.content': '这些服务条款适用于 IdeaVerdict（以下简称"服务提供方"）与用户（以下简称"客户"）之间关于使用人工智能驱动的利基分析平台的所有合同。',
  'legal.terms.section2.title': '2. 服务描述',
  'legal.terms.section2.content': '服务提供方提供一个基于人工智能的平台，用于分析和评估商业想法和利基。服务包括：',
  'legal.terms.section2.item1': '人工智能驱动的商业想法分析',
  'legal.terms.section2.item2': '评估市场潜力和竞争',
  'legal.terms.section2.item3': '生成利基建议',
  'legal.terms.section2.item4': '创建设开发者简报（构建者版套餐）',
  'legal.terms.section3.title': '3. 合同签订与注册',
  'legal.terms.section3.content': '合同通过在平台上注册并选择套餐而签订。客户确认：',
  'legal.terms.section3.item1': '已达到法定年龄并具有完全法律行为能力',
  'legal.terms.section3.item2': '在注册时提供真实信息',
  'legal.terms.section3.item3': '安全存储访问凭证',
  'legal.terms.section4.title': '4. 积分与计费',
  'legal.terms.section4.content': '人工智能功能的使用基于积分系统。每次人工智能查询消耗 30 积分。仅在成功响应后扣除积分。未使用的积分在计费周期结束时失效，且不予退款。',
  'legal.terms.section5.title': '5. 免责声明',
  'legal.terms.section5.content': '人工智能评估仅作为决策辅助工具，不保证商业成功。服务提供方不对基于人工智能分析做出的决策承担责任。对故意或重大过失的责任不受影响。',
  'legal.terms.section6.title': '6. 数据保护与保密性',
  'legal.terms.section6.content': '所有提交的商业想法均被保密处理，不会与第三方共享。个人数据的处理按照我们的隐私政策和适用的数据保护法进行。',
  'legal.terms.section7.title': '7. 终止',
  'legal.terms.section7.content': '客户可随时在当前计费周期结束时取消订阅。如果违反这些条款，服务提供方保留阻止访问平台的权利。',
  'legal.terms.section8.title': '8. 最终条款',
  'legal.terms.section8.content': '适用瑞士法律。管辖地为瑞士苏黎世。如果本条款的个别规定无效，其余规定的有效性不受影响。',
  'legal.terms.contact.title': '对服务条款有疑问？',
  'legal.terms.contact.content': '如果您对这些服务条款有疑问，请通过以下方式联系我们：',

  // 隐私政策页面
  'legal.privacy.title': '隐私政策',
  'legal.privacy.section1.title': '1. 数据控制者',
  'legal.privacy.section1.content': '本网站的数据控制者是位于瑞士苏黎世的 IdeaVerdict。我们非常重视保护您的个人数据，并按照法定数据保护法规对您的个人数据进行保密处理。',
  'legal.privacy.section2.title': '2. 收集的数据',
  'legal.privacy.section2.content': '我们收集并处理以下个人数据：',
  'legal.privacy.section2.item1': '注册数据：姓名、电子邮件地址、密码（加密）',
  'legal.privacy.section2.item2': '使用数据：IP地址、浏览器类型、访问时间',
  'legal.privacy.section2.item3': '商业想法和利基查询（匿名存储）',
  'legal.privacy.section2.item4': '支付信息（通过安全的第三方提供商）',
  'legal.privacy.section3.title': '3. 数据处理目的',
  'legal.privacy.section3.content': '您的数据用于以下目的：',
  'legal.privacy.section3.item1': '提供和改进我们的人工智能服务',
  'legal.privacy.section3.item2': '账户管理和身份验证',
  'legal.privacy.section3.item3': '计费和支付处理',
  'legal.privacy.section4.title': '4. 数据安全',
  'legal.privacy.section4.content': '我们采取技术和组织安全措施来保护您的数据免受操纵、丢失、破坏或未经授权的访问。所有数据传输均通过 SSL/TLS 加密。',
  'legal.privacy.section5.title': '5. 您商业想法的保密性',
  'legal.privacy.section5.content': '您提交的商业想法和利基查询将受到严格保密。它们不会与第三方共享，不会用于训练目的，并且可以根据要求完全删除。您的想法属于您。',
  'legal.privacy.section6.title': '6. 您的权利',
  'legal.privacy.section6.content': '关于您的个人数据，您享有以下权利：',
  'legal.privacy.section6.item1': '访问存储数据的权利',
  'legal.privacy.section6.item2': '更正不准确数据的权利',
  'legal.privacy.section6.item3': '删除您数据的权利',
  'legal.privacy.section6.item4': '数据可携带权',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content': '我们的网站仅使用技术上必要的 cookies 进行身份验证和会话管理。未经您明确同意，我们不使用跟踪 cookies 或第三方分析工具。',
  'legal.privacy.section8.title': '8. 本隐私政策的变更',
  'legal.privacy.section8.content': '我们保留根据变更的法律要求或服务变更调整本隐私政策的权利。当前版本始终可以在本页面上找到。',
  'legal.privacy.contact.title': '对隐私有疑问？',
  'legal.privacy.contact.content': '如果您对个人数据的处理有疑问，请通过以下方式联系我们：',

  'auth.passwordStrength.label': '密码强度',
  'auth.passwordStrength.weak': '弱',
  'auth.passwordStrength.medium': '中',
  'auth.passwordStrength.strong': '强',
  'auth.passwordStrength.veryStrong': '非常强',
  'auth.passwordStrength.minLength': '至少 8 个字符',
  'auth.passwordStrength.uppercase': '大写字母',
  'auth.passwordStrength.number': '数字',
  'auth.passwordStrength.special': '特殊字符',

  trial: {
    subtitle: '免费试用',
    upgrade: '立即升级',
    creditsRemaining: '剩余积分',
    inputHint: '试用版 - 无对话历史记录',
    banner: {
      title: '7天试用期激活',
      remaining: '剩余 {{days}} 天',
      credits: '可用积分',
      upgradeNow: '立即升级',
    },
    welcome: {
      title: '欢迎使用免费试用版！',
      desc: '免费试用我们的AI助手7天，并获得100积分。提出问题，探索各种可能性！',
    },
    info: {
      title: '试用限制',
      credits: '100积分，有效期7天',
      noHistory: '无对话历史',
      noSettings: '功能受限',
      upgrade: '升级以获得完整功能',
    },
  },

  // ─── 设置页面 ────────────────────────────────────────────────────────────
  'settings.title': '设置',
  'settings.subtitle': '管理您的帐户和偏好',
  'settings.backToOverview': '返回概览',
  'settings.subscriptionLink': '订阅与账单',
  'settings.saved': '更改已成功保存',
  'settings.changesSaved': '更改已保存',
  'settings.saveChanges': '保存更改',
  'settings.dataExported': '数据导出成功',

  // 标签页
  'settings.tabs.profile': '个人资料',
  'settings.tabs.preferences': '偏好设置',
  'settings.tabs.notifications': '通知',
  'settings.tabs.account': '帐户与套餐',

  // 个人资料
  'settings.profile.changePhoto': '更换照片',
  'settings.profile.photoHint': 'JPG、PNG 或 GIF（最大 2MB）',
  'settings.profile.uploading': '上传中...',
  'settings.profile.photoUpdated': '个人资料照片已更新！',
  'settings.profile.name': '姓名',
  'settings.profile.email': '电子邮件',
  'settings.profile.phone': '电话',
  'settings.profile.changePassword': '更改密码',
  'settings.profile.currentPassword': '当前密码',
  'settings.profile.newPassword': '新密码',
  'settings.profile.confirmPassword': '确认密码',

  // 偏好设置
  'settings.preferences.language': '语言',
  'settings.preferences.chooseLanguage': '选择语言',
  'settings.preferences.timezone': '时区',
  'settings.preferences.currency': '货币',

  // 通知
  'settings.notifications.emailTitle': '邮件通知',
  'settings.notifications.email.analysis': '分析完成',
  'settings.notifications.email.analysisDesc': '分析准备就绪时接收邮件',
  'settings.notifications.email.credits': '积分更新',
  'settings.notifications.email.creditsDesc': '关于积分和重置的通知',
  'settings.notifications.email.billing': '发票与付款',
  'settings.notifications.email.billingDesc': '关于发票和套餐变更的通知',
  'settings.notifications.email.newsletter': '新闻通讯',
  'settings.notifications.email.newsletterDesc': '技巧、更新和新功能',
  'settings.notifications.pushTitle': '推送通知',
  'settings.notifications.push.analysis': '分析完成',
  'settings.notifications.push.analysisDesc': '分析准备就绪时的浏览器通知',
  'settings.notifications.push.credits': '积分预警',
  'settings.notifications.push.creditsDesc': '积分余额不足时发出警告',

  // 帐户
  'settings.account.currentSubscription': '当前订阅',
  'settings.account.plan': '套餐',
  'settings.account.price': '价格',
  'settings.account.nextBilling': '下次计费',
  'settings.account.manageSubscription': '管理订阅与付款',
  'settings.account.dataPrivacy': '数据与隐私',
  'settings.account.exportData': '导出数据',
  'settings.account.deleteAccount': '删除帐户',

  // 删除模态框
  'settings.deleteModal.title': '删除帐户？',
  'settings.deleteModal.subtitle': '所有数据将被永久删除。',
  'settings.deleteModal.warning1': '所有分析和数据将被删除',
  'settings.deleteModal.warning2': '活跃订阅将立即取消',
  'settings.deleteModal.warning3': '无法退款',
  'settings.deleteModal.confirmLabel': '输入“{{word}}”以确认 *',
  'settings.deleteModal.cancel': '取消',
  'settings.deleteModal.confirm': '删除帐户',

  // ─── 订阅与账单 ─────────────────────────────────────────────
  'sub.backToOverview': '返回概览',
  'sub.settings': '设置',
  'sub.title': '订阅与账单',
  'sub.subtitle': '管理您的订阅、付款方式和发票',
  'sub.tab.overview': '概览',
  'sub.tab.payment': '付款方式',
  'sub.tab.billing': '账单地址',
  'sub.tab.history': '付款历史',
  'sub.memberSince': '会员起始',
  'sub.perMonth': '/月',
  'sub.baseCHF': '（{{amount}} 瑞士法郎基础价）',
  'sub.nextBilling': '下次计费',
  'sub.creditsUsed': '已用积分',
  'sub.paymentMethod': '付款方式',
  'sub.creditUsage': '积分使用情况',
  'sub.changePlan': '更改套餐',
  'sub.reactivate': '重新激活',
  'sub.cancelSub': '取消订阅',
  'sub.manageCards': '管理卡片',
  'sub.downloadInvoices': '下载发票',
  'sub.invoicesAvailable': '有 {{count}} 张发票可供下载为 PDF',
  'sub.accountSettings': '帐户设置',
  'sub.profileNotifications': '个人资料、通知等',
  // 欧元价格信息
  'sub.eurInfo': '价格以',
  'sub.eurLabel': '欧元',
  'sub.eurRate': '显示，汇率：',
  'sub.currentRate': '当前汇率',
  // 付款方式
  'sub.savedCards': '已保存的卡片',
  'sub.newCard': '新卡片',
  'sub.default': '默认',
  'sub.setDefault': '设为默认',
  'sub.validUntil': '有效期至',
  'sub.noCards': '未保存卡片',
  'sub.addFirstCard': '添加第一张卡片',
  'sub.securePayments': '安全支付',
  'sub.securePaymentsDesc': '所有支付数据均通过加密传输并安全存储于我们的支付提供商。我们不会存储完整的卡号。',
  // 账单地址
  'sub.billingAddress': '账单地址',
  'sub.edit': '编辑',
  'sub.name': '姓名',
  'sub.streetAddress': '街道及门牌号',
  'sub.zip': '邮政编码',
  'sub.city': '城市',
  'sub.country': '国家/地区',
  'sub.address': '地址',
  'sub.save': '保存',
  'sub.cancel': '取消',
  'sub.country.switzerland': '瑞士',
  'sub.country.germany': '德国',
  'sub.country.austria': '奥地利',
  'sub.country.netherlands': '荷兰',
  'sub.country.belgium': '比利时',
  // 付款历史
  'sub.paymentHistory': '付款历史',
  'sub.allInvoicesPDF': '下载所有带徽标的发票为 PDF',
  'sub.downloadAll': '全部下载',
  'sub.eurInvoiceNote': '发票始终以瑞士法郎开具。显示的欧元金额仅供参考。',
  'sub.date': '日期',
  'sub.description': '描述',
  'sub.net': '净额',
  'sub.vat': '增值税',
  'sub.total': '总额',
  'sub.status': '状态',
  'sub.pdf': 'PDF',
  'sub.invoices': '张发票',
  'sub.totalAmount': '总金额',
  // 更改套餐模态框
  'sub.changePlanTitle': '更改套餐',
  'sub.current': '当前',
  'sub.month': '/月',
  'sub.showLess': '收起',
  'sub.showMore': '显示更多 +{{count}}',
  'sub.switchPlan': '切换套餐',
  'sub.eurPriceNote': '价格以欧元显示（{{note}}）。账单以瑞士法郎结算。',
  // 取消模态框
  'sub.cancelTitle': '真的要取消订阅吗？',
  'sub.cancelIrreversible': '此操作无法撤销。',
  'sub.cancelWarning1': '所有剩余积分将失效',
  'sub.cancelWarning2': '降级至免费套餐',
  'sub.cancelWarning3': '失去所有高级功能',
  'sub.pauseInstead': '或者：暂停订阅？',
  'sub.pauseDesc': '改为暂停订阅并保留您的数据。',
  'sub.preferPause': '倾向于暂停',
  'sub.cancelReason': '取消原因',
  'sub.selectReason': '请选择...',
  'sub.reason.tooExpensive': '太贵了',
  'sub.reason.notUsing': '使用不够频繁',
  'sub.reason.missingFeatures': '缺少某些功能',
  'sub.reason.foundAlternative': '找到了替代方案',
  'sub.reason.other': '其他',
  'sub.confirmType': '确认：输入“CANCEL” *',
  'sub.cancelNow': '立即取消',
  // 添加卡片模态框
  'sub.addCardTitle': '添加新卡片',
  'sub.cardHolder': '持卡人 *',
  'sub.cardNumber': '卡号 *',
  'sub.expiryDate': '有效期 *',
  'sub.addCard': '添加卡片',
  // 更换卡片模态框
  'sub.choosePayment': '选择付款方式',
  'sub.active': '活跃',
  'sub.close': '关闭',
  // Toast 消息
  'sub.toast.cancelled': '您的订阅已在当前计费周期结束时取消。',
  'sub.toast.reactivated': '您的订阅已成功重新激活！',
  'sub.toast.planChanged': '套餐已成功更改为 {{plan}}！',
  'sub.toast.defaultChanged': '默认付款方式已更改。',
  'sub.toast.cannotDeleteDefault': '无法删除默认卡片。',
  'sub.toast.cardRemoved': '卡片已被移除。',
  'sub.toast.fillAll': '请填写所有字段。',
  'sub.toast.cardAdded': '新卡片已成功添加！',
  'sub.toast.billingSaved': '账单地址已保存。',
  'sub.toast.invoiceDownloaded': '发票 {{id}} 已下载！',
  'sub.toast.pdfError': '创建 PDF 时出错。',
  // 聊天界面
  'sub.notEnoughCredits': '积分不足',
  'sub.needCredits': '每个问题至少需要 {{count}} 积分。',
  'sub.creditsLow': '积分即将用尽',
  'sub.questionsLeft': '还可提问 {{count}} 次。',
  'sub.plan': '套餐',
  'sub.base': '基础价',
  'sub.unlimited': '无限',
  'sub.status.active': '活跃',
  'sub.status.cancelled': '已取消',
  'sub.status.paused': '已暂停',
  'sub.invoice': '发票',
  'sub.from': '发件人',
  'sub.to': '收件人',
  'sub.vatId': '增值税号',
  'sub.tel': '电话',
  'sub.invoiceDate': '发票日期',
  'sub.invoiceNumber': '发票编号',
  'sub.paymentStatus': '付款状态',
  'sub.creditCard': '信用卡',
  'sub.quantity': '数量',
  'sub.price': '单价',
  'sub.amount': '金额',
  'sub.subtotal': '小计',
  'sub.bank': '银行',
  'sub.card': '卡片',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': '张三',

  // ─── 管理面板 ─────────────────────────────────────────────────────────────
  'admin.title': '管理仪表板',
  'admin.subtitle': '控制中心',
  'admin.superAdmin': '超级管理员',
  'admin.logout': '退出登录',
  'admin.tabs.users': '用户管理',
  'admin.tabs.downgrades': '降级管理',
  'admin.tabs.tips': '每日提示',
  'admin.tabs.coupons': '优惠码',
  'admin.tabs.website': '网站编辑器',
  'admin.tabs.ai': '人工智能设置',
  'admin.tabs.transactions': '交易日志',
  'admin.tabs.stats': '统计数据',
  'admin.users.searchPlaceholder': '搜索用户（电子邮件或姓名）...',
  'admin.users.manageSubscription': '管理订阅',
  'admin.users.grantFree': '授予免费帐户',
  'admin.users.blockUser': '封禁用户',
  'admin.users.cancellationPlaceholder': '为什么取消订阅？',
  'admin.users.selectPlan': '选择套餐',
  'admin.users.subChanged': '{{name}} 的订阅已更改为 {{plan}}',
  'admin.users.noReasonGiven': '未提供原因',
  'admin.users.subCancelled': '{{name}} 的订阅已取消（有效期至 {{date}}）',
  'admin.users.paused': '已暂停',
  'admin.users.subPaused': '{{name}} 的订阅已暂停',
  'admin.users.subReactivated': '{{name}} 的订阅已重新激活',
  'admin.users.freeAccount': '免费帐户',
  'admin.users.blocked': '已封禁',
  'admin.users.cancelledExpiring': '已取消（即将到期）',
  'admin.users.cancelledOn': '取消日期：',
  'admin.users.endsOn': '结束日期：',
  'admin.users.daysRemaining': '剩余天数',
  'admin.users.expired': '（已过期）',
  'admin.users.total': '总计：',
  'admin.users.usersLabel': '用户',
  'admin.users.free': '免费',
  'admin.users.block': '封禁',
  'admin.users.unblock': '解封',
  'admin.users.unblockUser': '解封用户',
  'admin.users.selectAction': '选择操作',
  'admin.users.cancelSub': '取消订阅',
  'admin.users.cancelSubDesc': '月底取消',
  'admin.users.pauseSub': '暂停订阅',
  'admin.users.pauseSubDesc': '临时暂停',
  'admin.users.changePlan': '更改套餐',
  'admin.users.changePlanDesc': '切换到其他套餐',
  'admin.users.reactivateSub': '重新激活订阅',
  'admin.users.reactivateDesc': '撤销取消',
  'admin.users.alreadyCancelled': '订阅已取消',
  'admin.users.planLabel': '套餐',
  'admin.users.cancellationReasonOpt': '取消原因（可选）',
  'admin.users.cancelInfo1': '订阅将于以下日期结束',
  'admin.users.cancelInfo2': '（月底）。在此之前用户拥有完全访问权限。不退款。',
  'admin.users.newPlan': '新套餐',
  'admin.users.warning': '警告',
  'admin.users.blockDesc': '该用户将被立即登出，且无法再次登录。所有活动会话将被终止。',
  'admin.users.confirmUnblock': '确认解封',
  'admin.users.unblockDesc': '该用户可以再次登录并使用所有功能。',
  'admin.users.afterBlock': '封禁后：',
  'admin.users.afterUnblock': '解封后：',
  'admin.users.noAccountAccess': '无法访问帐户',
  'admin.users.noNewAnalyses': '无法进行新的分析',
  'admin.users.creditsStored': '积分和历史记录仍会保留',
  'admin.users.accessRestored': '帐户访问权限已恢复',
  'admin.users.allFeaturesAvail': '所有功能再次可用',
  'admin.users.creditsPreserved': '积分和历史记录已保留',
  'admin.users.downgrade': '降级套餐',
  'admin.users.grantFreeBtn': '授予免费',
  'admin.users.durationMonths': '时长（月）',
  'admin.users.months': '个月',
  'admin.users.freePlan': '免费',
  'admin.users.freeSummary': '获得',
  'admin.users.withCredits': '附带',
  'admin.users.credits': '积分',
  'admin.users.subInfo': '订阅信息',
  'admin.users.currentPlan': '当前套餐',
  'admin.users.joined': '加入日期',
  'admin.users.totalSpent': '总消费',
  'admin.users.paymentMethod': '付款方式',
  'admin.users.validThrough': '有效期至',
  'admin.users.billingAddress': '账单地址',
  'admin.users.transactionHistory': '交易历史',
  'admin.users.cancellationDate': '取消日期',
  'admin.users.validUntil': '有效期至（月底）',
  'admin.users.cancellationReason': '取消原因',
  'admin.users.noReason': '未提供原因',
  'admin.users.timeRemaining': '剩余时间',
  'admin.users.daysUntilDeactivation': '天后停用',
  'admin.table.user': '用户',
  'admin.table.plan': '套餐',
  'admin.table.subStatus': '订阅状态',
  'admin.table.cancellation': '取消',
  'admin.table.payment': '付款方式',
  'admin.table.spending': '消费',
  'admin.table.actions': '操作',
  'admin.actions.viewDetails': '查看详情',
  'admin.actions.manageSubscription': '管理订阅',
  'admin.actions.grantFree': '授予免费访问',
  'admin.actions.block': '封禁用户',
  'admin.actions.unblock': '解封用户',
  'admin.actions.cancel': '取消',
  'admin.actions.save': '保存',
  'admin.actions.delete': '删除',
  'admin.actions.confirm': '确认',
  'admin.actions.done': '完成',
  'admin.actions.edit': '编辑',
  'admin.actions.close': '关闭',
  'admin.table.status': '状态',
  'admin.filter.all': '全部',
  'admin.subscription.active': '活跃',
  'admin.subscription.cancelled': '已取消',
  'admin.subscription.paused': '已暂停',
  'admin.subscription.unknown': '未知',
  'admin.status.active': '活跃',
  'admin.status.inactive': '不活跃',
  'admin.status.pending': '待处理',
  'admin.status.approved': '已批准',
  'admin.status.rejected': '已拒绝',
  'admin.coupons.title': '优惠码管理',
  'admin.coupons.subtitle': '创建和管理优惠码',
  'admin.coupons.newCoupon': '新优惠码',
  'admin.coupons.registrationCoupons': '注册优惠码',
  'admin.coupons.trialCoupons': '试用访问优惠码',
  'admin.coupons.type': '类型',
  'admin.coupons.plan': '套餐',
  'admin.coupons.value': '价值',
  'admin.coupons.usage': '使用次数',
  'admin.coupons.validUntil': '有效期至',
  'admin.coupons.created': '创建日期',
  'admin.coupons.actions': '操作',
  'admin.coupons.copyCode': '复制代码',
  'admin.coupons.allPlans': '所有套餐',
  'admin.coupons.discount': '折扣',
  'admin.coupons.days': '天',
  'admin.coupons.months': '个月',
  'admin.coupons.free': '免费',
  'admin.coupons.unlimited': '无限',
  'admin.coupons.createRegistration': '创建注册优惠码',
  'admin.coupons.createTrial': '创建试用访问优惠码',
  'admin.coupons.couponCode': '优惠码',
  'admin.coupons.codePlaceholder': '例如：NF-7X3K9M',
  'admin.coupons.generateCode': '生成新代码',
  'admin.coupons.alertFillRequired': '请填写所有必填字段',
  'admin.coupons.alertSelectExpiry': '请选择有效期或启用“无限期有效”',
  'admin.coupons.alertCreateError': '创建优惠码时出错',
  'admin.coupons.confirmDelete': '您确定要删除此优惠码吗？',
  'admin.coupons.discountPercent': '折扣（%）',
  'admin.coupons.bonusCredits': '奖励积分',
  'admin.coupons.freeDuration': '免费时长',
  'admin.coupons.maxUses': '最大使用次数',
  'admin.coupons.expiryDate': '有效期',
  'admin.coupons.unlimitedValidity': '无限期有效',
  'admin.coupons.unlimitedUses': '无限使用',
  'admin.coupons.trialCredits': '试用积分',
  'admin.coupons.trialDuration': '试用时长',
  'admin.coupons.typePlaceholder': '例如：Early Bird、Partner、Influencer',
  'admin.coupons.duration': '时长',
  'admin.stats.totalUsers': '总用户数',
  'admin.stats.monthlyRevenue': '月收入',
  'admin.stats.activeSubscriptions': '活跃订阅数',
  'admin.stats.average': '平均值',
  'admin.stats.revenuePerUser': '每用户收入',
  'admin.stats.grossRevenue': '总收入',
  'admin.stats.net': '净额',
  'admin.stats.netRevenue': '净收入',
  'admin.stats.churnRate': '流失率',
  'admin.stats.planDistribution': '套餐分布',
  'admin.stats.users': '用户',
  'admin.stats.revenueByPlan': '各套餐收入',
  'admin.stats.recentActivity': '近期活动',
  'admin.stats.activity1': 'Thomas Weber 升级到构建者版',
  'admin.stats.activity2': '新用户注册',
  'admin.stats.activity3': 'Anna Schmidt 升级到专业版',
  'admin.stats.hoursAgo2': '2 小时前',
  'admin.stats.hoursAgo5': '5 小时前',
  'admin.stats.dayAgo1': '1 天前',
  'admin.stats.couponStats': '优惠码统计',
  'admin.stats.totalRedemptions': '总兑换次数',
  'admin.stats.activeCoupons': '活跃优惠码',
  'admin.stats.registrationRedemptions': '注册兑换次数',
  'admin.stats.trialRedemptions': '试用兑换次数',
  'admin.stats.couponDistribution': '优惠码分布',
  'admin.stats.registrationCoupons': '注册优惠码',
  'admin.stats.trialCoupons': '试用优惠码',
  'admin.stats.expiredInactive': '已过期/不活跃',
  'admin.stats.topCoupons': '兑换次数最多的优惠码',
  'admin.stats.redemptions': '兑换次数',
  'admin.stats.noCouponsRedeemed': '尚无优惠码被兑换',
  'admin.downgrade.pending': '待处理',
  'admin.downgrade.refunds': '退款',
  'admin.downgrade.sectionRequests': '请求',
  'admin.downgrade.sectionStats': '统计',
  'admin.downgrade.sectionRules': '规则',
  'admin.downgrade.pendingRequests': '待处理请求',
  'admin.downgrade.approvedRequests': '已批准请求',
  'admin.downgrade.rejectedRequests': '已拒绝请求',
  'admin.downgrade.activeRules': '活跃规则',
  'admin.downgrade.autoRules': '自动降级规则',
  'admin.downgrade.autoRulesDesc': '创建根据使用行为自动触发降级的规则',
  'admin.downgrade.newRule': '新规则',
  'admin.downgrade.totalRules': '规则总数',
  'admin.downgrade.triggeredActions': '已触发的操作',
  'admin.downgrade.conditionsAnd': '条件（AND 逻辑关联）',
  'admin.downgrade.action': '操作',
  'admin.downgrade.successTitle': '降级成功！',
  'admin.downgrade.successDesc': '用户已成功降级，退款已处理。',
  'admin.downgrade.closing': '关闭中...',
  'admin.downgrade.title': '降级用户',
  'admin.downgrade.currentPlan': '当前套餐',
  'admin.downgrade.spending': '消费',
  'admin.downgrade.availablePlans': '可用于降级的套餐',
  'admin.downgrade.perMonth': '/月',
  'admin.downgrade.refundCalc': '退款计算',
  'admin.downgrade.currentPlanLabel': '当前套餐',
  'admin.downgrade.newPlan': '新套餐',
  'admin.downgrade.remainingDays': '剩余天数',
  'admin.downgrade.daysOf': '15 天 / 30 天',
  'admin.downgrade.proRataRefund': '按比例退款',
  'admin.downgrade.importantNote': '重要提示',
  'admin.downgrade.warningDesc': '降级将立即执行。用户将失去高级功能访问权限，超额积分将被移除。',
  'admin.downgrade.processing': '处理中...',
  'admin.downgrade.execute': '执行降级',
  'admin.downgrade.notification': '通知',
  'admin.downgrade.noNotification': '无通知',
  'admin.downgrade.daysPeriod': '天宽限期',
  'admin.downgrade.created': '创建日期：',
  'admin.downgrade.triggered': '已触发',
  'admin.downgrade.noRules': '尚未创建规则',
  'admin.downgrade.createFirstRule': '创建第一条规则',
  'admin.downgrade.editRule': '编辑规则',
  'admin.downgrade.createRule': '创建新规则',
  'admin.downgrade.ruleName': '规则名称',
  'admin.downgrade.description': '描述',
  'admin.downgrade.allConditions': '条件（必须全部满足）',
  'admin.downgrade.addCondition': '添加条件',
  'admin.downgrade.type': '类型',
  'admin.downgrade.value': '值',
  'admin.downgrade.fromPlan': '从套餐',
  'admin.downgrade.toPlan': '到套餐',
  'admin.condition.inactivity': '不活跃',
  'admin.condition.creditUsage': '积分使用',
  'admin.condition.loginFrequency': '登录频率',
  'admin.condition.featureUsage': '功能使用',
  'admin.condition.supportTickets': '支持工单',
  'admin.operator.lessThan': '小于',
  'admin.operator.greaterThan': '大于',
  'admin.operator.equals': '等于',
  'admin.operator.between': '介于',
  'admin.unit.days': '天',
  'admin.unit.perMonth': '每月',
  'admin.unit.count': '次数',
  'admin.transactions.all': '所有交易',
  'admin.transactions.allCards': '所有卡片',
  'admin.transactions.notFound': '未找到交易记录',
  'admin.transactions.totalLabel': '总计',
  'admin.transactions.transactions': '笔交易',
  'admin.tips.title': '每日提示',
  'admin.tips.subtitle': '创建并管理向所有用户显示的提示',
  'admin.tips.active': '活跃',
  'admin.tips.currentlyShown': '此提示当前向所有用户显示',
  'admin.tips.createNew': '创建新提示',
  'admin.tips.generating': '生成中...',
  'admin.tips.generateAI': '生成人工智能提示',
  'admin.tips.titleLabel': '标题',
  'admin.tips.titlePlaceholder': '例如：每日提示',
  'admin.tips.category': '类别',
  'admin.tips.categoryTip': '提示',
  'admin.tips.categoryFeature': '新功能',
  'admin.tips.categoryProductivity': '生产力',
  'admin.tips.categoryUpdate': '更新',
  'admin.tips.content': '内容',
  'admin.tips.contentPlaceholder': '在此处为您的用户撰写提示...',
  'admin.tips.addTip': '添加提示',
  'admin.tips.allTips': '所有提示',
  'admin.tips.noTips': '尚未创建提示',
  'admin.tips.noTipsHint': '点击“生成人工智能提示”开始',
  'admin.noData': '无可用数据',
  'admin.range.7d': '7 天',
  'admin.range.30d': '30 天',
  'admin.range.90d': '90 天',
  'admin.range.1y': '1 年',
  'admin.actions.saveSettings': '保存设置',
  'admin.actions.create': '创建',
  'admin.downgrade.sectionReports': '报告',
  'admin.downgrade.settings': '降级设置',
  'admin.downgrade.autoApprove': '自动批准',
  'admin.downgrade.autoApproveDesc': '自动批准降级请求',
  'admin.downgrade.refundPolicy': '退款政策',
  'admin.downgrade.prorata': '按比例退款',
  'admin.downgrade.prorataDesc': '根据剩余天数按比例退款',
  'admin.downgrade.fullRefund': '全额退款',
  'admin.downgrade.fullRefundDesc': '全额退还差价',
  'admin.downgrade.noRefund': '不退款',
  'admin.downgrade.noRefundDesc': '降级但不退款',
  'admin.downgrade.daysRemaining15': '（剩余 15 天）',
  'admin.downgrade.requestsTitle': '降级请求',
  'admin.downgrade.approvalRate': '批准率',
  'admin.downgrade.mostCommonTransition': '最常见的转换',
  'admin.downgrade.mostCommonReason': '最常见的原因',
  'admin.downgrade.avgProcessingTime': '平均处理时间',
  'admin.downgrade.avgTimeDesc': '做出决定的平均时间',
  'admin.downgrade.totalRefunds': '退款总额',
  'admin.downgrade.pendingRefunds': '待处理退款',
  'admin.downgrade.summary': '摘要',
  'admin.downgrade.total': '总计',
  'admin.downgrade.csvDesc': '适用于 Excel、Google Sheets',
  'admin.downgrade.downloadCSV': '下载为 CSV',
  'admin.downgrade.jsonDesc': '适用于开发人员、API',
  'admin.downgrade.downloadJSON': '下载为 JSON',
  'admin.downgrade.exportInfo': '导出包含',
  'admin.downgrade.entries': '条所选时间段内的记录',
  'admin.downgrade.topReasons': '最常见的降级原因',
  'admin.downgrade.refundHistory': '退款历史',
  'admin.downgrade.noRefunds': '暂无退款',
  'admin.downgrade.statistics': '降级统计',
  'admin.downgrade.requests': '请求',
  'admin.downgrade.monthlyTrend': '月度趋势',
  'admin.downgrade.planTransitions': '套餐转换',
  'admin.downgrade.trend': '趋势（与上月相比）',
  'admin.downgrade.trendDesc': '降级越少越好',
  'admin.coupons.allPlansUniversal': '所有套餐（通用）',
  'admin.coupons.onlyStarter': '仅限入门版',
  'admin.coupons.onlyPro': '仅限专业版',
  'admin.coupons.onlyBuilder': '仅限构建者版',
  'admin.coupons.allPlansHint': '选择“所有套餐”以获得通用优惠码',
  'admin.coupons.discountOptional': '折扣 %（可选）',
  'admin.coupons.discountPlaceholder': '例如：50 表示 50% 折扣',
  'admin.coupons.bonusCreditsOptional': '奖励积分（可选）',
  'admin.coupons.bonusCreditsPlaceholder': '例如：500',
  'admin.coupons.freeDurationOptional': '免费时长（可选）',
  'admin.coupons.durationPlaceholder': '例如：30',
  'admin.coupons.freeDurationHint': '例如：30 天免费使用',
  'admin.coupons.noLimit': '无使用限制',
  'admin.coupons.noExpiry': '无到期日',
  'admin.coupons.creditsPlaceholder': '例如：100',
  'admin.coupons.creditsHint': '试用访问的积分数',
  'admin.coupons.trialDurationHint': '试用访问的有效期',
  'admin.coupons.autoCalculated': '根据试用时长自动计算',
  'admin.websiteEditor.title': '网站编辑器',
  'admin.websiteEditor.subtitle': '编辑主页的所有部分',
  'admin.websiteEditor.openPreview': '打开预览',
  'admin.websiteEditor.group.structure': '页面结构',
  'admin.websiteEditor.group.design': '设计与布局',
  'admin.websiteEditor.group.settings': '设置',
  'admin.websiteEditor.tab.navbar': '导航栏',
  'admin.websiteEditor.tab.howitworks': '工作原理',
  'admin.websiteEditor.tab.about': '关于我们',
  'admin.websiteEditor.tab.pricing': '价格',
  'admin.websiteEditor.tab.sections': '部分',
  'admin.websiteEditor.tab.media': '媒体',
  'admin.websiteEditor.tab.chatwidget': '与我们交流',
  'admin.websiteEditor.tab.invoice': '发票',
  'admin.websiteEditor.tab.legal': '法律信息',
  'admin.websiteEditor.tab.seo': '基础 SEO',
  'admin.websiteEditor.tab.advancedseo': '高级 SEO',
  'admin.websiteEditor.tab.versions': '版本',
  'admin.hero.title': '编辑主页英雄区',
  'admin.hero.subtitle': '主页的文本、按钮和统计数据',
  'admin.hero.reset': '重置',
  'admin.hero.save': '保存',
  'admin.hero.savedMsg': '英雄区数据已保存！',
  'admin.hero.badge': '徽章文本',
  'admin.hero.headings': '标题',
  'admin.hero.line1White': '第一行（白色）',
  'admin.hero.line2Gold': '第二行（金色）',
  'admin.hero.subtitleSection': '副标题',
  'admin.hero.line1': '第一行',
  'admin.hero.line2': '第二行',
  'admin.hero.buttons': '按钮',
  'admin.hero.primaryBtn': '主要按钮（金色）',
  'admin.hero.secondaryBtn': '次要按钮（边框）',
  'admin.hero.stats': '统计数据',
  'admin.hero.statN': '统计 {{n}}',
  'admin.hero.value': '数值',
  'admin.hero.label': '标签',
  'admin.hero.previewNote': '保存后，更改将在主页上可见。重新加载页面以查看预览。',

  // 想法历史
  'history.title': '想法历史',
  'history.countLabel': '{{count}} 次分析',
  'history.recentLabel': '您最近的分析',
  'history.exportAll': '全部导出',
  'history.metrics.marketSize': '市场规模',
  'history.metrics.competition': '竞争',
  'history.metrics.startingCapital': '启动资金',
  'history.metrics.timeToMarket': '上市时间',
  'history.metrics.profitPotential': '盈利潜力',
  'history.metrics.scalability': '可扩展性',
  'history.summary.title': '摘要',
  'history.download': '下载',
  'history.downloadJSON': '保存为 JSON',
  'history.downloadTXT': '保存为 TXT',
  'history.downloadPDF': '保存为 PDF',
  'history.fullAnalysis': '完整分析',
  'history.searchPlaceholder': '按标题或标签搜索...',
  'history.filterAll': '所有评级',
  'history.loading': '正在加载分析...',
  'history.noResults': '未找到结果',
  'history.empty': '暂无分析',
  'history.emptyHint': '在人工智能助手中开始分析',
  'history.delete': '删除',
  'history.cancel': '取消',
  'history.deleteModalTitle': '删除分析？',
  'history.deleteModalDesc': '“{{title}}”将被永久删除。',
  'history.errorLoading': '加载分析时出错',
  'history.deleteSuccess': '分析已成功删除',
  'history.deleteError': '删除分析时出错',
  'history.jsonExported': 'JSON 已导出',
  'history.txtExported': 'TXT 已导出',
  'history.allExported': '已导出 {{count}} 个想法',
  'history.analysisHeader': '想法分析',
  'history.titleLabel': '标题',
  'history.ratingLabel': '评级',
  'history.dateLabel': '日期',
  'history.creditsLabel': '积分',
  'history.analysisSection': '分析',

  // 概览
  'overview.title': '概览',
  'overview.last24h': '过去 24 小时',
  'overview.analysesToday': '今日分析',
  'overview.totalAnalyses': '总分析次数',
  'overview.successRate': '成功率',
  'overview.topRatings': '最高评级',
  'overview.recentActivity': '近期活动',
  'overview.viewAll': '查看全部',
  'overview.quickAccess': '快速访问',
  'overview.quick.newAnalysis': '开始新分析',
  'overview.quick.newAnalysisDesc': '开始新的人工智能驱动的利基分析',
  'overview.quick.myAnalyses': '我的分析',
  'overview.quick.myAnalysesDesc': '查看所有之前的分析',
  'overview.quick.buyCredits': '购买积分',
  'overview.quick.buyCreditsDesc': '更多积分，更多分析',
  'overview.quick.settings': '设置',
  'overview.quick.settingsDesc': '自定义个人资料和偏好',
  'overview.unlimitedCredits': '可用无限积分',
  'overview.creditsAvailable': '可用积分',
  'overview.upgradePlan': '升级套餐',
  'overview.buyCredits': '购买积分',
  'overview.creditUsage': '本月积分使用情况',
  'overview.available': '可用',

  // --- 管理面板新键值 ---
  'admin.transactions.upgrades': '升级',
  'admin.transactions.downgrades': '降级',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} 现在拥有 {{months}} 个月的免费 {{plan}} 套餐',
  'admin.users.blockSuccess': '{{name}} 已被封禁',
  'admin.users.unblockSuccess': '{{name}} 已被解封',
  'admin.users.removeFreeSuccess': '{{name}} 的免费状态已被移除',

  'admin.downgrade.plans.builder': '构建者版',
  'admin.downgrade.plans.pro': '专业版',
  'admin.downgrade.plans.starter': '入门版',
  'admin.downgrade.plans.free': '免费版',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': '发现新功能',
  'admin.tips.productivityBoost': '提升生产力',
  'admin.tips.importantUpdate': '重要更新',
  'admin.tips.tipOfDay': '每日提示',

  'admin.actions.activate': '激活',
  'admin.actions.deactivate': '停用',
  'admin.websiteEditor.tab.features': '功能',
  'admin.websiteEditor.tab.testimonials': '客户评价',
  'admin.websiteEditor.tab.faq': '常见问题',
  'admin.websiteEditor.tab.cta': '行动号召',
  'admin.websiteEditor.tab.footer': '页脚',
  'admin.websiteEditor.tab.design': '设计',
  'admin.websiteEditor.tab.customcode': '自定义代码',
  'admin.websiteEditor.tab.socials': '社交媒体',
  'admin.websiteEditor.tab.importexport': '导入/导出',

  // --- 人工智能设置编辑器 ---
  'admin.ai.title': '人工智能助手设置',
  'admin.ai.subtitle': '配置行为、风格和分析深度',
  'admin.ai.smartWeightingActive': '智能加权已激活',
  'admin.ai.smartWeightingDesc': '人工智能自动结合所有视角并进行智能加权。当选择多个预设时，第一个预设的权重更高（主要预设）。您也可以手动调整权重。',
  'admin.ai.modelTitle': 'IdeaVerdict 人工智能模型',
  'admin.ai.modelSubtitle': '为所有用户分析选择人工智能引擎',
  'admin.ai.activeModel': '激活的模型：',
  'admin.ai.activeModelDesc': '所有用户将接收来自此模型的响应。',
  'admin.ai.recommendations': '获得最佳效果的建议',
  'admin.ai.new': '新',
  'admin.ai.recommendationsDesc': '经过测试的预设组合，可提供最佳分析质量',
  'admin.ai.recommendationsInfo': '这些组合经过测试，能提供最佳效果。点击某个建议可直接应用。',
  'admin.ai.active': '已激活',
  'admin.ai.apply': '应用',
  'admin.ai.avoid': '避免',
  'admin.ai.excellentQuality': '优秀质量',
  'admin.ai.goodQuality': '良好质量',
  'admin.ai.poorQuality': '质量下降 - 不推荐',
  'admin.ai.proTips': '专业提示',
  'admin.ai.tip1Title': '2 个预设是最佳选择：',
  'admin.ai.tip1Desc': '清晰的视角，避免稀释',
  'admin.ai.tip2Title': '主要预设很重要：',
  'admin.ai.tip2Desc': '第一个预设的影响力最大',
  'admin.ai.tip3Title': '避免对立组合：',
  'admin.ai.tip3Desc': '"极端" + "创意" = 矛盾',
  'admin.ai.tip4Title': '最多 3 个预设：',
  'admin.ai.tip4Desc': '4 个或更多预设会使结果过于笼统',
  'admin.ai.warningManyPresets': '警告：预设过多',
  'admin.ai.warningManyPresetsDesc': '您已选择 {{count}} 个预设。这可能会稀释结果。',
  'admin.ai.warningRecommend': '建议：最多 2-3 个预设',
  'admin.ai.forOptimalResults': '以获得最佳效果。',
  'admin.ai.presets': '预设',
  'admin.ai.multiSelect': '（可多选）',
  'admin.ai.presetsDesc': '选择一个或多个预设。第一个预设是权重最高的主要预设。',
  'admin.ai.primaryPreset': '主要预设',
  'admin.ai.weightControl': '权重控制',
  'admin.ai.weightControlDesc': '调整每个预设对分析的影响强度',
  'admin.ai.manual': '手动',
  'admin.ai.automatic': '自动',
  'admin.ai.autoWeightingActive': '自动加权已激活：',
  'admin.ai.autoWeightingDesc': '权重根据预设数量自动优化。',
  'admin.ai.primary': '主要',
  'admin.ai.totalWeight': '总计',
  'admin.ai.shouldBe100': '应为 100%',
  'admin.ai.normalize': '标准化',
  'admin.ai.combinedSettings': '组合设置',
  'admin.ai.presetsCount': '个预设',
  'admin.ai.strictness': '严格度',
  'admin.ai.realism': '现实感',
  'admin.ai.creativity': '创造力',
  'admin.ai.detailLevel': '详细程度',
  'admin.ai.customInstructions': '自定义指令',
  'admin.ai.customInstructionsDesc': '与预设结合的附加指令',
  'admin.ai.customInstructionsPlaceholder': '例如：“关注 DACH 市场”、“始终使用具体数字”、“与现有竞争对手比较”、“始终用示例回答”...',
  'admin.ai.customInstructionsHint': '这些指令会自动与选定的预设结合。',
  'admin.ai.manualFinetuning': '手动微调',
  'admin.ai.manualFinetuningHint': '（可选，覆盖预设值）',
  'admin.ai.manualFinetuningDesc': '如果您想微调某些内容，请手动调整组合值。',
  'admin.ai.tone': '语气',
  'admin.ai.mild': '温和',
  'admin.ai.strict': '严格',
  'admin.ai.creative': '创意',
  'admin.ai.realistic': '现实',
  'admin.ai.conservative': '保守',
  'admin.ai.compact': '简洁',
  'admin.ai.detailed': '详细',
  'admin.ai.responseLength': '响应长度',
  'admin.ai.short': '简短明了',
  'admin.ai.medium': '中等',
  'admin.ai.long': '详细',
  'admin.ai.focusAreas': '分析重点领域',
  'admin.ai.autoRating': '自动评级',
  'admin.ai.autoRatingDesc': '每次分析自动收到评级（好/一般/差）',
  'admin.ai.showSources': '显示来源',
  'admin.ai.showSourcesDesc': '在响应中引用数据源和市场数据',
  'admin.ai.hidePreview': '隐藏预览',
  'admin.ai.showPreview': '显示预览',
  'admin.ai.aiBehavior': '人工智能行为',
  'admin.ai.length': '长度',
  'admin.ai.liveExample': '实时示例',
  'admin.ai.testSettings': '测试您的设置',
  'admin.ai.selectExampleQuestion': '选择示例问题：',
  'admin.ai.userAsks': '用户提问：',
  'admin.ai.generating': '人工智能正在生成响应...',
  'admin.ai.generateExample': '生成示例响应',
  'admin.ai.aiResponds': '人工智能助手回复：',
  'admin.ai.generateHint': '点击“生成示例响应”以查看人工智能如何使用您的设置进行回复。',
  'admin.ai.reset': '重置',
  'admin.ai.saved': '已保存！',
  'admin.ai.saveSettings': '保存设置',

  // --- 表格标题 ---
  'admin.coupons.code': '代码',
  'admin.coupons.credits': '积分',

  // --- 人工智能模型描述 ---
  'admin.ai.model.standardDesc': '平衡的分析，质量高。大多数利基评估和想法验证的最佳选择。',
  'admin.ai.model.preciseAnalyses': '精确分析',
  'admin.ai.model.bestBalance': '最佳平衡',
  'admin.ai.model.recommended': '推荐',
  'admin.ai.model.fastDesc': '快速响应，适合快速利基检查、头脑风暴和初步评估。速度至关重要时的理想选择。',
  'admin.ai.model.fast': '快速',
  'admin.ai.model.fastestResponses': '最快响应',
  'admin.ai.model.thinkingDesc': '具有高级逻辑思维的深度分析。适用于复杂的市场分析、批判性评估和战略规划。',
  'admin.ai.model.deepestAnalysis': '最深入分析',
  'admin.ai.model.logicalThinking': '逻辑思维',
  'admin.ai.model.strategy': '战略',

  // --- 人工智能预设名称与描述 ---
  'admin.ai.preset.strict.name': '严格分析',
  'admin.ai.preset.strict.desc': '批判性、基于事实、不粉饰。无情地暴露弱点。',
  'admin.ai.preset.extreme.name': '极端分析',
  'admin.ai.preset.extreme.desc': '最大严格度、无情批评、聚焦最坏情况。适用于艰难的现实检查。',
  'admin.ai.preset.professional.name': '专业',
  'admin.ai.preset.professional.desc': '客观、结构化、平衡。像经验丰富的商业顾问。',
  'admin.ai.preset.realistic.name': '现实',
  'admin.ai.preset.realistic.desc': '诚实且务实。关注可行的实施和真实的市场数据。',
  'admin.ai.preset.creative.name': '创意与激励',
  'admin.ai.preset.creative.desc': '鼓舞人心、富有创意、积极正面。寻找机会和非常规路径。',
  'admin.ai.preset.balanced.name': '平衡',
  'admin.ai.preset.balanced.desc': '批评与激励的良好结合。默认模式。',
  'admin.ai.preset.investor.name': '投资者视角',
  'admin.ai.preset.investor.desc': '像风险资本家。关注规模化、投资回报率和退出策略。',
  'admin.ai.preset.startup-coach.name': '创业教练',
  'admin.ai.preset.startup-coach.desc': '面向创始人的实践导师。关注快速实施和 MVP。',
  'admin.ai.preset.market-researcher.name': '市场研究员',
  'admin.ai.preset.market-researcher.desc': '数据驱动和分析性。深入的市场和竞争分析。',
  'admin.ai.preset.risk-analyst.name': '风险分析师',
  'admin.ai.preset.risk-analyst.desc': '关注风险和 worst-case 情景。用于现实规划。',

  // --- 重点领域 ---
  'admin.ai.focus.marktanalyse': '市场分析',
  'admin.ai.focus.wettbewerb': '竞争',
  'admin.ai.focus.monetarisierung': '盈利模式',
  'admin.ai.focus.risiken': '风险',
  'admin.ai.focus.finanzen': '财务',
  'admin.ai.focus.skalierung': '规模化',
  'admin.ai.focus.innovation': '创新',
  'admin.ai.focus.trends': '趋势',
  'admin.ai.focus.differenzierung': '差异化',
  'admin.ai.focus.umsetzung': '实施',
  'admin.ai.focus.zielgruppe': '目标受众',
  'admin.ai.focus.marketing': '市场营销',

  // --- 语气选项 ---
  'admin.ai.tone.direkt': '直接而 blunt',
  'admin.ai.tone.professionell': '专业且客观',
  'admin.ai.tone.ehrlich': '诚实且务实',
  'admin.ai.tone.motivierend': '激励且积极',
  'admin.ai.tone.freundlich': '友好且支持',
  'admin.ai.tone.akademisch': '学术且分析',

  // --- 示例问题 ---
  'admin.ai.question.niche': '您推荐哪个有利可图的利基？',
  'admin.ai.question.evaluate': '评价我的想法：一个面向狗主人的应用',
  'admin.ai.question.trends': '目前哪些趋势有潜力？',
  'admin.ai.question.sharpen': '我怎样才能锐化我的利基？',

  'admin.ai.rec.bestCombination.title': '🏆 最佳组合（2 个预设）',
  'admin.ai.rec.bestCombination.desc': '批判但建设性，包含具体行动步骤',
  'admin.ai.rec.bestCombination.useCase': '推荐用于大多数分析',

  'admin.ai.rec.balancedThree.title': '⚖️ 平衡组合（3 个预设）',
  'admin.ai.rec.balancedThree.desc': '专业、现实且对投资者友好',
  'admin.ai.rec.balancedThree.useCase': '用于全面的商业分析',

  'admin.ai.rec.creativeDriven.title': '💡 创意与激励（2 个预设）',
  'admin.ai.rec.creativeDriven.desc': '鼓舞人心，附带实用实施技巧',
  'admin.ai.rec.creativeDriven.useCase': '用于构思和头脑风暴',
  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': '打开菜单',
  'header.home': '首页',
  'header.notifications': '通知',
  'header.settings': '设置',
  'header.profile': '个人资料',
  'sidebar.collapse': '收起侧边栏',
  'sidebar.expand': '展开侧边栏',
  'sidebar.close': '关闭菜单',
  'sidebar.plan': '套餐',
  'sidebar.backToWebsite': '返回网站',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': '欢迎回来',
  'overview.greetingSub': '这是你的裁决工作台动态。',
  'overview.heroCta': '新裁决',
  'overview.currentPlan': '当前套餐',
  'overview.creditsLabel': '积分',
  'overview.usedThisCycle': '本周期已用',
  'overview.resetsOn': '重置于',
  'overview.unlimitedTitle': '无限',
  'overview.builderPerk': '你拥有完整的 Builder 访问权限 — 无限制。',
  'overview.runOne': '运行裁决',
  'overview.lastVerdicts': '你最近的 5 次裁决',
  'overview.noActivity': '还没有裁决 — 开始你的第一次分析',
  'overview.tipTitle': '提示',
  'overview.tipBody': '让一个想法经过两种语言测试 — 如果裁决软化了，你的假设是本地的，不是普世的。',
  'onboard.skip': "跳过",
  'onboard.cta.next': "下一步",
  'onboard.cta.start': "开始使用",
  'onboard.s1.title': "欢迎使用 IdeaVerdict",
  'onboard.s1.body': "在动手之前，让 AI 给你的创业想法下个判决。",
  'onboard.s2.title': "残酷但诚实的判决",
  'onboard.s2.body': "不吹捧，不奉承。真实的市场数据、真实的竞争对手、真实的风险。",
  'onboard.s3.title': "导出为 PDF 的 Builder 报告",
  'onboard.s3.body': "生成 25-75 页的报告，涵盖完整架构、财务模型与市场进入策略。",
  'onboard.s4.title': "你准备好，我们就开始",
  'onboard.s4.body': "注册即可在一分钟内拿到你的第一个判决。",
  'builderReport.title': "正在生成你的 Builder 报告",
  'builderReport.subtitle': "完整分析 + 开发者简报——完成后以 PDF 下载。",
  'builderReport.idea': "你的想法",
  'builderReport.ideaPlaceholder': "描述你的商业想法（留空则使用你最近讨论过的想法）…",
  'builderReport.cta': "生成报告",
  'builderReport.credits': "积分",
  'builderReport.deductedNow': "成功后扣除",
  'builderReport.dontClose': "请不要关闭此窗口——生成需要 30-90 秒。",
  'builderReport.done': "PDF 已下载——请查看你的下载文件夹。",
  'builderReport.failed': "生成失败",
  'builderReport.close': "关闭",
  'builderReport.cancel': "取消",
  'builderReport.running': "生成中…",
  'builderReport.retry': "重试",
  'builderReport.unknownError': "生成失败。你的积分应已退还。",
  'builderReport.signInRequired': "需要登录才能生成报告。",
  'builderReport.ideaRequired': "请描述你的想法，AI 才有东西可分析。",
  'builderReport.fromChat': "来自你当前的对话",
  'builderReport.noIdeaDetected': "将使用我们一直讨论的那个想法。",
  'builderReport.contextHint': "AI 会使用本次对话的全部内容——不会凭空编出新想法。",
  'builderReport.step.core': "生成核心分析",
  'builderReport.step.market': "补充扩展市场分析",
  'builderReport.step.tech': "补充技术架构",
  'builderReport.step.financials': "补充财务模型",
  'builderReport.step.compet': "补充竞争情报",
  'builderReport.step.gtm': "补充市场进入策略",
  'builderReport.step.deepdive': "补充行业深度剖析",
  'builderReport.step.pdf': "正在合成 PDF…",
  'briefing.title': "正在生成你的开发者简报",
  'briefing.subtitle': "11 个章节的技术简报——完成后以 PDF 下载。",
  'briefing.ideaPlaceholder': "描述你的商业想法（留空则使用你最近讨论过的想法）…",
  'briefing.cta': "生成简报",
  'briefing.step.core': "生成开发者简报",
  'briefing.step.pdf': "正在合成 PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "更多积分 + 50 页报告",
  'pricing.gold.credits': "每月 12,500 积分",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "顶级套餐 + 75 页报告",
  'pricing.platinum.credits': "每月 15,000 积分",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "zh" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "仅剩 {{count}} 积分！",
  'trial.upgradeNow': "立即升级",
  'trial.upgradeNowArrow': "立即升级 →",
  'trial.creditsExhausted': "积分已用完",
  'trial.upgradeForUnlimited': "升级以无限使用",
  'trial.noCreditsPlaceholder': "没有剩余积分…",
  'hero.badgeHonest': "诚实、无偏见的 AI",
  'hero.badge60sec': "60 秒出判决",
  'hero.badge20Lang': "20 多种语言",
  'hero.widget.label': "想法判决",
  'hero.widget.passed': "通过",
  'hero.widget.demoIdea': "面向医学生的 AI 导师",
  'hero.widget.market': "市场",
  'hero.widget.demand': "需求",
  'hero.widget.competition': "竞争",
  'hero.widget.verdictReady': "判决就绪 · 47 秒",
  'hero.widget.riskFlagged': "已标记风险",
  'hero.widget.crowdedMarket': "市场拥挤 · 4 家在位玩家",
  'hero.widget.suggestedPivot': "建议转向",
  'hero.widget.nicheBySpecialty': "按专科细分",
  'hero.widget.feasibilityGain': "可行性 +38%",
  'hero.widget.analysisDone': "分析完成",
  'hero.widget.metrics56': "6 项指标中的 5 项",
  'hero.stats.verdictSpeed': "判决速度",
  'cta.badge': "60 秒出判决",
  'cta.subtitleEnd': "不靠瞎猜。",
  'cta.signinPrompt': "已有账户？登录",
  'cta.trustTrial': "7 天免费试用",
  'cta.trustNoCard': "无需绑卡",
  'cta.trustCancel': "随时取消",
  'footer.themeLabel': "主题：",
  'footer.lightMode': "浅色模式",
  'footer.darkMode': "深色模式",
  'footer.sectionProduct': "产品",
  'footer.sectionLegal': "法律",
  'nav.switchLight': "切换到浅色模式",
  'nav.switchDark': "切换到深色模式",
  'features.badge': "为什么选 IdeaVerdict",
  'features.mainFeatureLabel': "核心亮点",
  'chatError.planRestriction': "此功能需要更高级的套餐。",
  'chatError.creditDeduction': "支付处理失败，请重试。",
  'chatError.aiService': "AI 服务暂时不可用，未扣除你的积分，请重试。",
  'chatError.parseError': "收到意外的响应格式，请重试。",
  'chatError.sessionExpired': "你的会话已过期，请重新登录。",
  'chatError.timeout': "请求超时，请重试。",
  'chatError.generic': "获取响应失败，请重试。",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "zh" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "仅剩 {{count}} 积分！",
  'trial.outOfCredits': "积分已用完",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "市场拥挤 · 4 家在位玩家",
  'hero.widget.nicheBySpec': "按专科细分",
  'hero.widget.feasibilityUp': "可行性 +38%",
  'hero.widget.fiveOfSix': "6 项指标中的 5 项",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25 页 Builder Report",
  'pricing.gold.report': "50 页 Builder Report",
  'pricing.platinum.report': "75 页 Builder Report",
  'auth.bestValue': "最具性价比",
  'auth.elite': "尊享",
  'builderReport.friendlyError': "本次未能完成你的报告。你的积分未被扣除——请稍后再试。",
  'builderReport.persistHint': "如果问题持续，请联系 support@ideaverdict.ai。",
};
